import { serverApi } from "./serverApi";
import { Scenario } from "../types/scenarioTypes";

export const scenarioService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    getAllScenarios: build.query<Array<Scenario>, string>({
      query: () => ({
        url: "/scenarios/all-scenarios"
      })
    }),
    createScenario: build.mutation<number, Scenario>({
      query: (request) => ({
        url: "/scenarios/scenario",
        method: "POST",
        body: request
      })
    }),
    updateScenario: build.mutation<string, Scenario>({
      query: (request) => ({
        url: "/scenarios/scenario",
        method: "PUT",
        body: request
      })
    }),
    deleteScenario: build.mutation<string, number>({
      query: (scenarioId) => ({
        url: "/scenarios/scenario",
        method: "DELETE",
        params: { id: scenarioId }
      })
    }),
    updateScenarioRequests: build.mutation<string, Scenario>({
      query: (scenario) => ({
        url: "/scenarios/scenario/requests",
        method: "POST",
        body: {
          scenarioId: scenario.id,
          assignedRequests: scenario.assignedRequests
        }
      })
    }),
  })
});

export const {
  useGetAllScenariosQuery,
  useCreateScenarioMutation,
  useUpdateScenarioMutation,
  useDeleteScenarioMutation,
  useUpdateScenarioRequestsMutation
} = scenarioService;